import cn from 'classnames'
import { ErrorMessage, Field, useField } from 'formik'
import { type FC } from 'react'
import {
  type FieldProps,
  type TextAreaProps
} from '../../SignUpForm.interface'
import FieldLabel from '../FieldLabel/FieldLabel'
import styles from './FormInput.module.scss'

type InputProps = FieldProps | TextAreaProps

const FormikInput: FC<InputProps> = ({
  className,
  name,
  label,
  optionalText,
  type = 'text',
  ...props
}) => {
  const [, meta] = useField(name)

  const hasErrror = meta.error && meta.touched

  return (
    <div className="form-field">
      <label htmlFor={name}>
        {label && <FieldLabel label={label} optional={optionalText} />}
        <Field
          type={type}
          name={name}
          id={name}
          className={cn(
            styles['form-input__input'],
            {
              [styles['form-input__input-error']]:
              hasErrror
            },
            className != null ? styles[className] : ''
          )}
          aria-invalid={hasErrror}
          // eslint-disable-next-line react/jsx-props-no-spreading
          {...props}
        />
      </label>
      <ErrorMessage
        className={styles['form-input__error-message']}
        component="div"
        name={name}
      />
    </div>
  )
}

export default FormikInput
